export const classes = {
  card: 'rounded-[20px] border border-solid border-black/10 bg-white/[0.82] shadow-aurora-card overflow-hidden dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  cardHeader:
    'px-[18px] pt-[15px] border-b border-solid border-black/[0.06] dark:border-white/[0.08]',
  ordersList: 'w-full py-0',
};
